import React from 'react';
import { projectExamples } from '../data/content';
import { SectionLabel } from './ui/SectionLabel';
import { Reveal } from './ui/Reveal';
export function ProjectExamples() {
  return <section className="bg-cream px-4 py-14 sm:px-5 sm:py-24" data-id="element-170" data-mp="pr8ka3pm8z0z">
      <div className="mx-auto max-w-6xl" data-id="element-171" data-mp="pstflvjr8lzw">
        <Reveal data-id="element-172" data-mp="l08nqzkesiz0">
          <SectionLabel data-id="element-173" data-mp="l0ii0zchlcai">Uno sguardo dentro</SectionLabel>
          <h2 className="display mx-auto mt-5 max-w-[26ch] text-center text-[1.7rem] text-ink sm:text-[3.1rem]" data-id="element-174" data-mp="kyxj6xj5376u">
            Non sono solo idee.{' '}
            <span className="text-orange" data-id="element-175" data-mp="ts2bb5ycuty3">
              Vedono cosa costruire e perché funziona.
            </span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] font-semibold leading-relaxed text-ink/65 sm:mt-5 sm:text-lg" data-id="element-176" data-mp="18oa2wrc3exne">
            Ogni pagina unisce il disegno della costruzione al meccanismo che la
            fa funzionare, così la spiegazione arriva insieme all’istruzione.
          </p>
        </Reveal>

        <ul className="rail mt-9 -mx-4 px-4 pb-2 sm:mx-0 sm:mt-12 sm:gap-5 sm:px-0 sm:pb-0 sm:grid-cols-2 lg:grid-cols-4" data-id="element-177" data-mp="1a6e2t8pi827u">
          {projectExamples.map((example, index) => <li key={example.title} className="h-full" data-id="element-178" data-mp="1e89104c51zhe" data-mpi={index}>
              <Reveal delay={index * 0.05} className="h-full" data-id="element-179" data-mp="1j6u1m4vayl6d">
                <article className="flex h-full flex-col overflow-hidden rounded-[1.5rem] border-2 border-ink/10 bg-white shadow-edge transition-[transform,box-shadow] duration-150 ease-snap hover:-translate-y-1 hover:shadow-card sm:rounded-[1.75rem]" data-id="element-180" data-mp="1j594q8limq5c">
                  <div className="overflow-hidden border-b-2 border-ink/10 bg-sand" data-id="element-181" data-mp="1xunh7pke1noy">
                    <img src={example.image} alt={`Schema illustrato di ${example.title}`} className="aspect-[3/4] w-full object-cover" loading="lazy" width={900} height={1200} data-id="element-182" data-mp="21xbs02snx4ok" />
                  </div>
                  <div className="flex flex-1 flex-col p-5 sm:p-6" data-id="element-183" data-mp="7klxbiugzrg4">
                    <p className="text-[10px] font-black uppercase tracking-[0.16em] text-orange" data-id="element-184" data-mp="cido29jdp7iq">
                      {example.label}
                    </p>
                    <h3 className="mt-2 text-base font-black leading-snug text-ink sm:text-lg" data-id="element-185" data-mp="1ftt6i0de7816">
                      {example.title}
                    </h3>
                    <p className="mt-auto pt-3 text-[11px] font-black uppercase tracking-[0.1em] text-ink/45 sm:pt-4" data-id="element-186" data-mp="1ouhjqsuyp4d0">
                      {example.concept}
                    </p>
                  </div>
                </article>
              </Reveal>
            </li>)}
        </ul>

        <p className="mt-4 text-center text-[10px] font-black uppercase tracking-[0.14em] text-ink/35 sm:hidden" data-id="element-187" data-mp="1ttkcpexo3k4m">
          Scorri per vedere tutto
        </p>
      </div>
    </section>;
}